import './accountCard.scss';
import React from 'react';
import { useContext } from 'react';
import { AppContext } from '../../../../context/appContext';
import UserAvatar from '../../../../common/businessCommon/user/userAvatar/userAvatar';
import UserName from '../../../../common/businessCommon/user/userName/userName';
import { getAccountName } from '../../../../services/authorizationService';

export function AccountCard() {
    const { state } = useContext(AppContext);
    const { userInfo } = state;
    const accountDisplayName = getAccountName(userInfo);

    return (
        <div className="account-card">
            <div className="account-card-avatar">
                <UserAvatar
                    src={userInfo.avatar}
                    className="data-user-avatar"
                    width={70}
                    showUserLevel={userInfo.show_user_level}
                    userLevelInfo={userInfo.user_level}
                />
            </div>
            <div className="account-card-info">
                <div className="info-name truncate-text">
                    <UserName
                        name={userInfo.user_name}
                        className="data-user-name"
                        userMedalInfo={userInfo.user_medal}
                        showUserLevel={userInfo.show_user_level}
                        transcate={true}
                    />
                </div>
                <div className="info-display-name truncate-text">{accountDisplayName}</div>
            </div>
        </div>
    );
}
